export const APPLIED_RATE_DATA = 'APPLIED_RATE_DATA';